export default {"src":"/_next/static/media/welcome.mono.10239869.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};